define(
    [
        'jQuery'],
function($)
{
    var SearchmaskLoader = function(element, options)
    {
        var defaults = {
            'menu-element': '.tabnavigation-searchmask--item',
            'route': '/extern/contentarea/',
            'loadingClass': 'is-loading',
            'js-route-template': '%booking%/external/index',
            'active-menu-class': 'is-active'
        };
        this._searchmaskCache = [];
        this.element = element;
        this.options = $.extend({}, defaults, options || {});;
        this.element.on('click', this.options['menu-element'], $.proxy(this._switchTab, this));
    };
    SearchmaskLoader.prototype = {
        /**
         * Handler for tab switching
         * @param e - event
         * @returns {boolean} to prevent default behavior
         * @private
         */
        _switchTab: function(e) {
            var target = $(e.target),
                element = target.closest(this.options['menu-element']),
                bookingType = element.data('fcse-bookingtype'),
                self = this;

            // if element is active - don't process event
            if (element.hasClass(this.options['active-menu-class'])) {
                return false;
            }
            this.element.addClass(this.options['loadingClass']);
            // if it is in cache - load from cache
            if (typeof this._searchmaskCache[bookingType] !== 'undefined') {
                this._contentLoaded(this._searchmaskCache[bookingType], bookingType);
                self._stopLoading();
            // else - load via ajax
            } else {
                $.ajax({
                    url: this.options['route'],
                    data: {
                        'bookingType': bookingType,
                        'area': 'form'
                    },
                    success: function(data)
                    {
                        self._contentLoaded(data, bookingType);
                        self._stopLoading();
                    },
                    error: $.proxy(this._stopLoading, this)
                });
            }
            return false;
        },
        /**
         * Load content to searchmask
         * @param data - html
         * @param bookingType
         * @private
         */
        _contentLoaded : function(data, bookingType)
        {
            var jsTemplate = this.options['js-route-template'],
                jsPath = jsTemplate.replace(/%booking%/g, bookingType),
                init;
            this.element.html(data);
            // if history available - use history. If not available - do nothing with url
            if (history.replaceState) {
                history.replaceState([], '', '/' + bookingType);
            }
            if (require.defined(jsPath)) {
                init = require(jsPath);
                init();

            } else {
                require([jsPath]);
            }
            this._searchmaskCache[bookingType] = data;
        },
        /**
         * Remove loading status
         * @private
         */
        _stopLoading: function()
        {
            this.element.removeClass(this.options['loadingClass']);
        }
    };
    return SearchmaskLoader;
});


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/searchmaskloader/searchmaskloader.js